export default "__VITE_ASSET__569d74b5__"